<template>
    <b-row v-if="row.status === 'Started'">
        <div class="OTloading">
            <div class="OTloadersmall"></div>
        </div>
    </b-row>
    <b-row v-else-if="row.status === 'Error'">
        <div class="OTloading">
            <div class="ot-icon-err-ecm-status"></div>
        </div>
    </b-row>
    <b-row v-else-if="row.status === 'Finished' && (row.errordescription === '' || row.errordescription === '**')">
        <div class="OTloading">
            <div class="ot-icon-ok-ecm-status"></div>
        </div>
    </b-row>
    <b-row v-else-if="row.status === 'Finished' && row.errordescription !== '' && row.errordescription !== '**' && row.executionStatusCode != 0">
        <div class="OTloading">
            <div class="ot-icon-err-ecm-status"></div>
        </div>
    </b-row>
    <b-row v-else-if="row.status === 'Finished' && row.errordescription !== '' && row.errordescription !== '**' && row.executionStatusCode === 0">
        <div class="OTloading">
            <div class="ot-icon-ok-ecm-status"></div>
        </div>
    </b-row>

</template>

<script>

export default {
    props: ['row'],
     created() {
        var that = this;
        const a = that;
    }
}

</script>